import { Ballot } from '../interfaces/ballot';

export const initialBallots: {
  currentBallots: Ballot[];
} = {
  currentBallots: [],
};
